import { TestCase } from "@/common/api.service"
import { FETCH_TEST_CASE, FETCH_INDIVIDUAL_TEST_CASE, ADD_TEST_CASE, UPDATE_TEST_CASE,RESET_STATE, DELETE_TEST_CASE} from "./actions.type"
import { SET_TEST_CASE, SET_INDIVIDUAL_TEST_CASE, SET_ERROR_TEST_CASE,STATE_RESET } from "./mutations.type"

const initialState = () => {
    return {
        testcase: [],
        individualtestcase: [],
        testcaseerrors: null,
    }
}

let state = initialState()

const getters = {
    testcase(state) {
        return state.testcase
    },
    individualtestcase(state) {
        return state.individualtestcase
    }
}

const actions = {
    async [FETCH_TEST_CASE](context, slug) {
        const { data } = await TestCase.get(slug)
        context.commit(SET_TEST_CASE, data.data)
        return data;
    },
    async [FETCH_INDIVIDUAL_TEST_CASE](context, slug) {
        const { data } = await TestCase.get(slug)
        context.commit(SET_INDIVIDUAL_TEST_CASE, data.data)
        return data;
    },  
    async [ADD_TEST_CASE](context, payload) {
        return await TestCase.create(payload, '')
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_TEST_CASE, error.response.data.errors)
        });
    },     
    async [UPDATE_TEST_CASE](context, payload) {
        return await TestCase.update(payload, payload.tc_id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_TEST_CASE, error.response.data.errors)
        });
    },  
    async [DELETE_TEST_CASE] (context, id) {
        return await TestCase.delete(id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_TEST_CASE, error.response.data.errors)
        });
    },    
    [RESET_STATE]({ commit }) {
        commit(STATE_RESET);
    }
}

const mutations = {
    [SET_ERROR_TEST_CASE](state, error) {
        state.testcaseerrors = error
    },      
    [SET_TEST_CASE](state, testcasedata) {
        state.testcase = testcasedata
    },
    [SET_INDIVIDUAL_TEST_CASE](state, individualtestcase) {
        state.individualtestcase = individualtestcase
    },    
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    } 
};

export default {
    state,
    getters,
    actions,
    mutations
};